import addToBasketMutation from '../helpers/addToBasketMutation'

export default async function({ props, state, graphql }) {
  const ids = props.currentFiles.map(id => {
    return `"${id}"`
  })

  const { group } = state.get('app.user')
  let sharedUUID = null

  if (group.shared) {
    sharedUUID = state.get('shared.uuid')
  }

  const order = await addToBasketMutation(
    graphql,
    'addOrderItems',
    `mediaIds: [${ids.join()}] ${
      sharedUUID ? `, sharedUUID: "${sharedUUID}"` : ''
    }`
  )

  return { ...order }
}



// WEBPACK FOOTER //
// ./src/modules/Basket/actions/addToBasket.js